"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAddressSwaggerMetadata = exports.getAddressesSwaggerMetadata = exports.deleteAddressSwaggerMetadata = exports.getAddressSwaggerMetadata = void 0;
exports.createAddressSwaggerMetadata = createAddressSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
// Swagger metadata for the createAddress method
function createAddressSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Create Address",
        description: "Creates a new address with the provided details.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Address creation payload",
        schema: {
            type: "object",
            properties: {
                addressTypeLid: { type: "number", example: 0 },
                address1: { type: "string", example: "SD Road" },
                area: { type: "string", example: "sec-bad" },
                countryId: { type: "number", example: 1 },
                stateId: { type: "number", example: 24 },
                cityId: { type: "number", example: 46 },
                pinCode: { type: "string", example: "500025" },
                email: { type: "string", example: "rohit@divami.com" },
                phoneNumber: { type: "string", example: "7095639485" },
                alternatePhoneNumber: { type: "string", example: "9177184763" },
                supportNumber: { type: "string", example: "1234567890" },
            },
        },
    }), (0, swagger_1.ApiResponse)({ status: 201, description: "Address created successfully" }), (0, swagger_1.ApiResponse)({ status: 400, description: "Invalid input data" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
}
// Swagger metadata for the getAddress method
const getAddressSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Get address data by ID" }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the address",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Address data retrieved successfully",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({ status: 404, description: "Address not found" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.getAddressSwaggerMetadata = getAddressSwaggerMetadata;
// Swagger metadata for the deleteAddress method
const deleteAddressSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Delete address by ID" }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the address to delete",
        type: Number,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({ status: 200, description: "Address deleted successfully" }), (0, swagger_1.ApiResponse)({ status: 404, description: "Address not found" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.deleteAddressSwaggerMetadata = deleteAddressSwaggerMetadata;
// Swagger metadata for the addressList method
const getAddressesSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Address list with pagination, sorting, and search",
    }), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        type: Number,
        description: "Page number (default: 1)",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        type: Number,
        description: "Number of items per page (default: 10)",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        type: String,
        description: "Sorting format: field:order (e.g., address1:ASC, cityId:DESC)",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        type: String,
        description: "Search term for address details",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "List of addresses retrieved successfully",
    }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.getAddressesSwaggerMetadata = getAddressesSwaggerMetadata;
// Swagger metadata for the updateAddress method
const updateAddressSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Update address by ID" }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the address to update",
        type: Number,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Fields to update in the address",
        schema: {
            type: "object",
            properties: {
                addressTypeLid: { type: "number", example: 0 },
                address1: { type: "string", example: "New SD Road" },
                area: { type: "string", example: "new-sec-bad" },
                countryId: { type: "number", example: 1 },
                stateId: { type: "number", example: 24 },
                cityId: { type: "number", example: 46 },
                pinCode: { type: "string", example: "500026" },
                email: { type: "string", example: "updated@divami.com" },
                phoneNumber: { type: "string", example: "7095639400" },
                alternatePhoneNumber: { type: "string", example: "9177184777" },
                supportNumber: { type: "string", example: "0987654321" },
            },
        },
    }), (0, swagger_1.ApiResponse)({ status: 200, description: "Address updated successfully" }), (0, swagger_1.ApiResponse)({ status: 400, description: "Bad Request - Validation Error" }), (0, swagger_1.ApiResponse)({ status: 404, description: "Address not found" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.updateAddressSwaggerMetadata = updateAddressSwaggerMetadata;
